import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Card, CardContent, Stack, Box, Typography, Avatar } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CategoryIcon from '@mui/icons-material/Category';
import { LoadingWrapper } from '../loading';

const IncomeStatsCards = ({ stats, isLoading }) => {
  const statsCards = [
    {
      title: 'Total Incomes',
      value: stats.total_incomes || 0,
      icon: <TrendingUpIcon />,
      color: 'primary.main',
    },
    {
      title: 'Total Amount',
      value: Number(stats.total_amount || 0).toLocaleString(undefined, { maximumFractionDigits: 2 }),
      icon: <AccountBalanceIcon />,
      color: 'success.main',
    },
    {
      title: 'Categories',
      value: stats.categories_count || 0,
      icon: <CategoryIcon />,
      color: 'warning.main',
    },
  ];

  return (
    <LoadingWrapper
      isLoading={isLoading}
      skeletonCount={3}
      showSectionTitle
      sectionTitle="Overview"
      containerSx={{ width: '100%' }}
    >
      <Grid container spacing={2}>
        {statsCards.map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card>
              <CardContent>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      {stat.title}
                    </Typography>
                    <Typography variant="h4">{stat.value}</Typography>
                  </Box>
                  <Avatar sx={{ bgcolor: stat.color, color: 'primary.contrastText' }}>{stat.icon}</Avatar>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </LoadingWrapper>
  );
};

IncomeStatsCards.propTypes = {
  stats: PropTypes.shape({
    total_incomes: PropTypes.number,
    total_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    categories_count: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default IncomeStatsCards;